import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { buildExadisReturnClaimItems } from 'domains/order/Order.mapper';
import {
  buildExadisReturnListLineKey,
  getExadisReturnListFetchStatus,
  getExadisReturnListItems,
  initExadisReturnClaimForm,
} from 'domains/order/Order.store';
import ExadisReturnListTable from 'pages/MyOrdersPage/ExadisReturnList/ExadisReturnListTable';
import ClaimFormModal from 'pages/MyOrdersPage/OrderClaims/ClaimFormModal';
import { BlackButton, Flex, MarginBox } from 'UI';

const ExadisReturnList = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const items = useSelector(getExadisReturnListItems);
  const fetchStatus = useSelector(getExadisReturnListFetchStatus);
  const [isClaimOpen, setIsClaimOpen] = useState(false);

  const handleCreateReturn = () => {
    if (items.length === 0) {
      return;
    }
    dispatch(
      initExadisReturnClaimForm({
        claimItems: buildExadisReturnClaimItems(items),
        lineKeys: items.map(buildExadisReturnListLineKey),
      }),
    );
    setIsClaimOpen(true);
  };

  return (
    <>
      <MarginBox mb={20}>
        <Flex justify={'flex-end'}>
          <BlackButton onClick={handleCreateReturn} disabled={items.length === 0}>
            {t('exadis_return_list.action.create_return', 'Create Return')}
          </BlackButton>
        </Flex>
      </MarginBox>
      <ExadisReturnListTable items={items} fetchStatus={fetchStatus} />
      <ClaimFormModal isOpen={isClaimOpen} setIsOpen={setIsClaimOpen} />
    </>
  );
};

export default ExadisReturnList;
